import { createContext, useContext, useEffect, useState } from "react";
import es from "@/locales/es";
import en from "@/locales/en";
import fr from "@/locales/fr";
import pt from "@/locales/pt";

const locales = { es, en, fr, pt };
const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(
    () => localStorage.getItem("montalban-lang") || "es"
  );

  useEffect(() => {
    localStorage.setItem("montalban-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t: locales[lang] }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
